import {
  Primary13SemiBold,
  Primary14ExtendedSemiBold,
  Section,
  Box,
  Flex
} from '@sequencehq/core-components'
import {
  DayOfMonthField,
  Skeleton,
  TextAreaField,
  TextInputField
} from '@sequencehq/core-components'
import { useAtom } from 'jotai'
import { pricingDetailsAtom } from '../atoms/reviewPricing.primitives.atoms'
import { PaymentTermsSelect } from 'components/PaymentTerms/PaymentTermsSelect'
import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { HighlightFieldPathsOnHover } from '../../../HighlightFieldPathsOnHover'

const FIELD_WIDTH = '226px'
const FIELD_STYLES = {
  label: {
    ...Primary13SemiBold
  }
}

const SectionHeader = () => (
  <Box {...Primary14ExtendedSemiBold} marginBottom="8px">
    Additional information
  </Box>
)
export const AdditionalInformation = () => {
  const [pricingDetails, setPricingDetails] = useAtom(pricingDetailsAtom)
  const merchantSettings = useQuery(
    dashboard20240730Client.getMerchantForSequenceAccount
  )

  if (merchantSettings.isPending) {
    return (
      <Box>
        <SectionHeader />
        <Skeleton width="100%" height="320px" />
      </Box>
    )
  }

  return (
    <Box data-testid="reviewPricing.additionalInformation">
      <SectionHeader />
      <Section variant="emphasized" padding="16px">
        <Flex gap="16px" flexDirection="column">
          <HighlightFieldPathsOnHover
            fieldPaths={['billingSchedule.recurrenceDayOfMonth']}
          >
            <DayOfMonthField
              data-testid="reviewPricing.recurrenceDayOfMonth"
              label="Billing day"
              value={pricingDetails.recurrenceDayOfMonth}
              onChange={newValue =>
                setPricingDetails({
                  recurrenceDayOfMonth: newValue
                })
              }
              width={FIELD_WIDTH}
              styles={FIELD_STYLES}
            />
          </HighlightFieldPathsOnHover>
          <PaymentTermsSelect
            data-testid="reviewPricing.paymentTerms"
            useFieldVariant
            label="Payment terms"
            placeholder="Select payment terms"
            value={pricingDetails.defaultDueDateDays ?? undefined}
            onChange={newValue =>
              setPricingDetails({
                defaultDueDateDays: newValue
              })
            }
            customTerms={
              typeof merchantSettings.data?.defaultDueDateDays !== 'undefined'
                ? [merchantSettings.data.defaultDueDateDays]
                : []
            }
            width="226px"
          />
          <TextAreaField
            data-testid="reviewPricing.memo"
            placeholder="Optional memo"
            label="Invoice memo"
            value={pricingDetails.memo}
            onChange={newValue => setPricingDetails({ memo: newValue })}
            width="470px"
          />
          <TextInputField
            data-testid="reviewPricing.purchaseOrderNumber"
            label="Purchase order number"
            placeholder="Optional PO number"
            value={pricingDetails.purchaseOrderNumber}
            onChange={e =>
              setPricingDetails({
                purchaseOrderNumber: e.target.value
              })
            }
            width={FIELD_WIDTH}
            styles={FIELD_STYLES}
          />
          <TextInputField
            data-testid="reviewPricing.label"
            label="Billing schedule label"
            placeholder="Optional customer label"
            value={pricingDetails.label}
            onChange={e =>
              setPricingDetails({
                label: e.target.value
              })
            }
            width={FIELD_WIDTH}
            styles={FIELD_STYLES}
          />
        </Flex>
      </Section>
    </Box>
  )
}
